export interface IPropertyEnvironmentOptionView {
    IsStreetView?: Boolean
    IsViewDistance?: Boolean
    IsViewRoute?: Boolean
    IsViewRouteDirection?: Boolean
    IsViewTime?: Boolean
    ObjectId?: Number
    Radius?: Number
    ZoomLevel?: Number
}

export class PropertyEnvironmentOptionView implements IPropertyEnvironmentOptionView {
    IsStreetView?: Boolean
    IsViewDistance?: Boolean
    IsViewRoute?: Boolean
    IsViewRouteDirection?: Boolean
    IsViewTime?: Boolean
    ObjectId?: Number
    Radius?: Number
    ZoomLevel?: Number

    constructor(option: IPropertyEnvironmentOptionView) {
        this.IsStreetView = option.IsStreetView || false
        this.IsViewDistance = option.IsViewDistance || false
        this.IsViewRoute = option.IsViewRoute || false
        this.IsViewRouteDirection = option.IsViewRouteDirection || false
        this.IsViewTime = option.IsViewTime || false
        this.ObjectId = option.ObjectId
        this.Radius = option.Radius
        this.ZoomLevel = option.ZoomLevel
    }
}

export interface IPropertyEnvironmentOptionPoint {
    Id?: Number
    ObjectId?: Number
    POI_Group?: String
    POI_Type?: String
}

export class PropertyEnvironmentOptionPoint implements IPropertyEnvironmentOptionPoint {
    Id?: Number
    ObjectId?: Number
    POI_Group?: String
    POI_Type?: String

    constructor(option: IPropertyEnvironmentOptionPoint) {
        this.Id = option.Id
        this.ObjectId = option.ObjectId
        this.POI_Group = option.POI_Group
        this.POI_Type = option.POI_Type
    }
}